/**
 * track.ts — measurement for /pro-member-v12 (plan "Measurement built into v12").
 *
 * GA4: gtag custom events (consent-gated — gtag only exists once ConsentManager
 * has loaded it). Clarity: custom events, same names, so recordings can be
 * filtered by them. Every event carries page = the route it fired on, without slashes
 * (pro-member-v12 on the review route; pro-member where the banner + hero run on the
 * live page, step 1j), so the two routes never share a label.
 * D3: "checkout opened" is GA4's automatic page_view on /checkout/membership.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
  }
}

export function pm12Track(name: string, params: Record<string, string> = {}): void {
  if (typeof window === 'undefined') return;
  window.gtag?.('event', name, { page: window.location.pathname.replace(/^\/+|\/+$/g, ''), ...params });
  window.clarity?.('event', name);
}
